import $ from 'jquery';

const checkClass = (el, className) => el.hasClass(className);

export default class {
	constructor() {
		this.selectors = {
			el: '.js-fav',
			toggle: '.js-fav-toggle',
			text: '.js-fav-text',
			indicate: '.js-fav-indicate'
		};

		this.classes = {
			active: 'favorite_state_active'
		};

		this.text = {
			full: 'Убрать из избранного',
			empty: 'Добавить в избранное'
		};

		this.$el = $(this.selectors.el);
		this.$toggle = $(this.selectors.toggle);
		this.$text = $(this.selectors.text);
		this.$indicate = $(this.selectors.indicate);
	}

	toggle(e) {
		const $target = $(e.target);
		const $el = $target.closest(this.$el);

		$el.toggleClass(this.classes.active);
		this.setText($el);
		this.setNumber($el);
	}

	setText(el) {
		const $text = el.find(this.$text);
		if (checkClass(el, this.classes.active)) {
			$text.text(this.text.full);
		} else {
			$text.text(this.text.empty);
		}
	}

	setNumber(el) {
		let number = Number(this.$indicate.attr('data-count'));

		if (checkClass(el, this.classes.active)) {
			number = ++number;
			this.$indicate.attr('data-count', number);
		} else {
			number = --number;
			this.$indicate.attr('data-count', number);
		}
	}

	render() {
		if (this.$el.length) {
			this.$toggle.on('click', e => this.toggle(e));
		}
	}

}



/** WEBPACK FOOTER **
 ** ./app/blocks/favorite/favorite.js
 **/